export const getAgeByDate = (birthDate: Date) => {
  if (birthDate.getTime() >= Date.now()) {
    return 0;
  }
  const ageDifMs = Date.now() - birthDate.getTime();
  const ageDate = new Date(ageDifMs); // miliseconds from epoch
  return Math.abs(ageDate.getUTCFullYear() - 1970);
};

export const formatBirthDate = (date: Date, locale?: string) => {
  const formatter = new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });

  return formatter.format(date);
};

export const getLocalizedDateFormat = (locale?: string) => {
  const testDate = new Date(2000, 0, 2);

  const formattedDate = formatBirthDate(testDate, locale);

  return formattedDate
    .replace('02', 'dd')
    .replace('01', 'mm')
    .replace('2000', 'yyyy');
};
